import { useMutation } from 'react-query';
import request from '../../../../helpers/request';

const mutationFn = ({ acceptanceId, payload }) => {
  return request.post(
    'Acceptance/change_settings_desks',
    payload,
    'Не удалось изменить настройку работы столов',
    'Error',
    undefined,
    { acceptanceId }
  );
};

export const useChangeDesksSettingsMutation = (options) => {
  return useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data !== 'Error' && typeof options?.onSuccess === 'function') {
        options.onSuccess(data, variables);
      }
    },
  });
};
